var render = function render(){var _vm=this,_c=_vm._self._c;return _c('popup',{attrs:{"type":"checkbox"},on:{"confirm":_vm.handleConfirm,"close":_vm.handleClose}},[(_vm.url.url)?_vm._t("preview",null,{"url":_vm.url}):_vm._t("upload")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }